export const HR = () => <div className="h-px bg-black" />
